module.exports = __webpack_public_path__ + "static/media/emailMessage.7234968f.txt";